import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import leaf from "../../Assets/Projects/leaf.png";
import emotion from "../../Assets/Projects/emotion.png";
import portfolio from "../../Assets/Projects/portfolio.png";
import littleLemon from "../../Assets/Projects/little-lemon.png";
import weather from "../../Assets/Projects/weather.PNG";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={weather}
              isBlog={false}
              title="Weather App"
              description="A weather app built using React.js and OpenWeatherMap API. The app displays the current weather of a city and also the air quality. The weather first access user's location and fetch the weather of that location. The user can also search for a city and get the weather of that particular city. I have also added a feature to change the background image according to the weather. The app is buit using the power of Reactjs, Vite and TailwindCSS."
              ghLink="https://github.com/ahmohil/Weather-App"
              demoLink="https://ahmohil.github.io/Weather-App/"
            />
          </Col>
          
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={littleLemon}
              isBlog={false}
              title="Little Lemon"
              description="A website built using pure Reactjs for a Mediterranean restaurant that prides itself on serving up traditional recipes with a touch of modern flair. The website is hosted on github pages. It is fully responsive and mobile friendly."
              ghLink="https://github.com/ahmohil/little-lemon"
              demoLink="https://ahmohil.github.io/little-lemon/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={portfolio}
              isBlog={false}
              title="Portfolio"
              description="A personal protfolio website built with React.js and React Bootstrap. The website is hosted on github pages. It is fully responsive and mobile friendly."
              ghLink="https://github.com/ahmohil/https://github.com/ahmohil/portfolio"
              demoLink="https://ahmohil.github.io/portfolio"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={emotion}
              isBlog={false}
              title="Face Recognition and Emotion Detection"
              description="Trained a CNN classifier using 'FER-2013 dataset' with Keras and tensorflow backened. The classifier sucessfully predicted the various types of emotions of human. And the highest accuracy obtained with the model was 60.1%.
              Then used Open-CV to detect the face in an image and then pass the face to the classifer to predict the emotion of a person."
              ghLink="https://github.com/ahmohil/face_and_emotion_detection"
            />
          </Col>

        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
